export const CLIENTS = [
    "MultiBank",
    "OneRoyal",
    "MexSports",
    "Scope Markets",
    "Vantage",
    "AETOS",
    "XLibre"
];

export const SERVICES = [
    {
        slug: "performance-marketing",
        number: "01",
        title: "Performance Marketing",
        snapshotAnchor: "performance-marketing",
        excerpt: "Generate more qualified leads and active clients through targeted advertising campaigns designed to reach the right audience at the right time.",
        deliverables: [
            "Google Ads & search marketing",
            "Meta, TikTok & social advertising",
            "Programmatic & native advertising",
            "Retargeting & conversion tracking"
        ]
    },
    {
        slug: "content-social",
        number: "02",
        title: "Content & Social Media Marketing",
        snapshotAnchor: "content-social",
        excerpt: "Grow your visibility across search engines and social platforms with content that answers customer questions, keeps your audience engaged, and attracts qualified traffic.",
        deliverables: [
            "SEO & content strategy",
            "Content creation & publishing",
            "Community management",
            "Content clusters & distribution",
            "Audience growth & engagement"
        ]
    },
    {
        slug: "kol-influencer",
        number: "03",
        title: "KOL/Influencer Marketing",
        snapshotAnchor: "kol-influencer",
        excerpt: "Reach and influence the right audience through trusted creators, industry experts, and key opinion leaders who align with your brand and business goals.",
        deliverables: [
            "KOL & influencer sourcing",
            "UGC content production",
            "Campaign management",
            "Performance creatives"
        ]
    },
    {
        slug: "event-marketing",
        number: "04",
        title: "Event Marketing",
        snapshotAnchor: "event-marketing",
        excerpt: "Create memorable event experiences that build brand awareness, generate quality leads, and help turn prospects into customers.",
        deliverables: [
            "Event strategy & planning",
            "Event production & logistics",
            "Lead capture & engagement"
        ]
    },
    {
        slug: "customer-journey-retention",
        number: "05",
        title: "Customer Journey & Retention",
        snapshotAnchor: "customer-journey-retention",
        excerpt: "Turn interest into action and keep clients trading longer with funnels, automation, and lifecycle campaigns built to capture leads, improve conversions, and maximize customer lifetime value.",
        deliverables: [
            "Landing pages & funnels",
            "Marketing automation",
            "Email, SMS & push lifecycle campaigns",
            "Reactivation campaigns",
            "VIP segmentation",
            "Tracking & analytics"
        ]
    },
    {
        slug: "branding-sponsorship",
        number: "06",
        title: "Branding & Sponsorship",
        snapshotAnchor: "branding-sponsorship",
        excerpt: "Build stronger brand visibility through strategic partnerships, sponsorships, and brand assets that help your business stand out in competitive markets.",
        deliverables: [
            "Brand strategy",
            "Sponsorship activation",
            "Brand identity design",
            "Creative production"
        ]
    },
    {
        slug: "pr-services",
        number: "07",
        title: "PR Services",
        snapshotAnchor: "pr-services",
        excerpt: "Earned media placements across top-tier finance, tech, and mainstream publications in Sub-Saharan Africa, engineered for narrative control and unshakeable market credibility.",
        deliverables: [
            "Press relations",
            "Thought leadership",
            "Crisis management",
            "Awards & recognition"
        ]
    },
    {
        slug: "affiliate-onboarding",
        number: "08",
        title: "Affiliate Onboarding Services",
        snapshotAnchor: "affiliate-onboarding",
        excerpt: "Recruitment and vetting of top-tier affiliates and Introducing Brokers across regional markets, built to drive volume and secure long-term partner loyalty.",
        deliverables: [
            "Partner recruitment",
            "VIP onboarding",
            "Affiliate partner vetting",
            "Performance reviews"
        ]
    },
    {
        slug: "csr",
        number: "09",
        title: "CSR",
        snapshotAnchor: "csr",
        excerpt: "High-impact CSR initiatives tailored to Sub-Saharan Africa, engineered to build unshakeable community trust and strengthen alignment with local regulators.",
        deliverables: [
            "Event strategy",
            "Partner selection",
            "Campaign activation",
            "Impact reporting"
        ]
    }
];

export const INDUSTRIES = [
    {
        slug: "forex",
        kicker: "Vertical 01",
        title: "Forex Brokers",
        copy: "Driving funded accounts for licensed forex brokers across Africa and beyond. We speak spreads, swap, and STP/ECN fluently, and we know what each regulator will and won't let you say."
    },
    {
        slug: "fintech",
        kicker: "Vertical 02",
        title: "Fintech Brands",
        copy: "Wallets, neobanks, payments and trading apps. We build campaigns for fintech brands that need acquisition velocity without losing brand credibility."
    },
    {
        slug: "financial-services",
        kicker: "Vertical 03",
        title: "Financial Services Firms",
        copy: "Brokerages, investment platforms and trading firms. We grow the businesses building the next decade of African and global capital markets."
    }
];

export const SNAPSHOTS = [
    {
        slug: "multibank",
        client: "Tier-1 forex broker",
        title: "Tier-1 broker, Tier-1 growth.",
        category: "forex",
        pillar: "performance-marketing",
        tag: "Performance · Branding",
        metric: "+218% qualified FTDs",
        image: "https://static.prod-images.emergentagent.com/jobs/53238dfc-9902-4045-ab2f-6fcec5697290/images/c39835a31f4fd728c26555b38447392892f1d6b26e57044f0b13e047f37de3b7.png",
        excerpt: "Scaled paid acquisition across 14 geos while rebuilding the brand for institutional credibility."
    },
    {
        slug: "oneroyal",
        client: "Multi-asset broker",
        title: "Brand refresh, performance ignition.",
        category: "branding",
        pillar: "branding-sponsorship",
        tag: "Brand · Creative",
        metric: "4.1x ROAS uplift",
        image: "https://static.prod-images.emergentagent.com/jobs/53238dfc-9902-4045-ab2f-6fcec5697290/images/148a63fdc8b99149b84b0a424e86becd110e252612e834e2e9a907e9522a44f2.png",
        excerpt: "Repositioned a heritage broker for the next decade with a sharp identity and a launch campaign that converted."
    },
    {
        slug: "rallytrade",
        client: "Trading firm",
        title: "Trading firm growth from zero to one.",
        category: "trading-firm",
        pillar: "performance-marketing",
        tag: "Performance · Affiliate",
        metric: "12k evaluations / mo",
        image: "https://images.pexels.com/photos/5831529/pexels-photo-5831529.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        excerpt: "Stood up an end-to-end acquisition stack across paid, affiliate, and content to scale evaluations and funded accounts."
    },
    {
        slug: "scope",
        client: "Top 5 multi-asset broker",
        title: "Multi-region launch playbook.",
        category: "forex",
        pillar: "content-social",
        tag: "Performance · SEO",
        metric: "9 markets, 11 months",
        image: "https://static.prod-images.emergentagent.com/jobs/53238dfc-9902-4045-ab2f-6fcec5697290/images/db6f112ec4c0103c39f5f2290b9b90e3826f5dd9e8d9f6ab51a02642cff72f61.png",
        excerpt: "Operationalised a market-entry playbook for compliant rollouts across Africa and beyond."
    },
    {
        slug: "mexsports",
        client: "Brokerage",
        title: "Sponsorship to acquisition pipeline.",
        category: "branding",
        pillar: "branding-sponsorship",
        tag: "Sponsorship · CRM",
        metric: "3.2M brand reach",
        image: "https://images.unsplash.com/photo-1691491918178-8a2e68b44919?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxjcmVhdGl2ZSUyMHRlYW0lMjBhZ2VuY3klMjBkYXJrfGVufDB8fHx8MTc4MDMzMTUyOXww&ixlib=rb-4.1.0&q=85",
        excerpt: "Turned high-cost sponsorship inventory into a measurable acquisition channel with creative and CRM activation."
    },
    {
        slug: "helix",
        client: "Fintech brand",
        title: "Fintech launch in a cold cycle.",
        category: "fintech",
        pillar: "performance-marketing",
        tag: "Performance · Community",
        metric: "85k verified KYCs",
        image: "https://static.prod-images.emergentagent.com/jobs/53238dfc-9902-4045-ab2f-6fcec5697290/images/c39835a31f4fd728c26555b38447392892f1d6b26e57044f0b13e047f37de3b7.png",
        excerpt: "Cold-cycle launch strategy with cross-platform creative and high-signal community building for a fintech brand."
    },
    {
        slug: "northfunded",
        client: "Trading firm",
        title: "Evaluator scale across continents.",
        category: "trading-firm",
        pillar: "affiliate-onboarding",
        tag: "Affiliate · Media",
        metric: "+412% sign-ups",
        image: "https://images.pexels.com/photos/5831529/pexels-photo-5831529.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        excerpt: "Affiliate-led growth model with media diversification to remove single-channel dependency."
    }
];

// Ordered list of service pillars used to render the anchored Snapshot sections.
// Slugs match /snapshot#<anchor> deep links from the What We Do page.
export const PILLAR_ANCHORS = [
    { anchor: "performance-marketing", title: "Performance Marketing" },
    { anchor: "content-social", title: "Content & Social Media Marketing" },
    { anchor: "kol-influencer", title: "KOL / Influencer Marketing" },
    { anchor: "event-marketing", title: "Event Marketing" },
    { anchor: "customer-journey-retention", title: "Customer Journey & Retention" },
    { anchor: "branding-sponsorship", title: "Branding & Sponsorship" },
    { anchor: "pr-services", title: "PR Services" },
    { anchor: "affiliate-onboarding", title: "Affiliate Onboarding" },
    { anchor: "csr", title: "CSR" }
];

// Long-form case studies rendered as an expandable list on the Snapshot page.
// Each entry follows the same template: about -> brief -> solution -> results -> CTA.
export const CASE_STUDIES = [
    {
        slug: "vantage-markets-performance-marketing",
        client: "Vantage Markets",
        service: "Performance Marketing",
        image: "https://images.unsplash.com/photo-1763888450809-4125d93fa56b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxmb3JleCUyMHRyYWRpbmclMjBjaGFydHMlMjBkYXJrfGVufDB8fHx8MTc4MDMzMTUxMnww&ixlib=rb-4.1.0&q=85",
        about: "Vantage Markets is a global multi-asset broker providing traders with access to trade the financial markets including forex, indices, commodities, shares, ETFs, and more. With a presence in multiple regions around the world, the company is focused on delivering a reliable trading experience for their clients through innovative technology and competitive trading conditions.",
        briefLabel: "The Brief",
        brief: "Vantage Markets was looking for better ways to generate more quality leads across key African markets. Like many brokers, they faced growing competition, low quality leads and rising marketing costs. For them, it was not just about generating leads, they wanted to attract a large base of high quality leads that can easily convert into active clients. Our performance marketing activities were built around strategy, storytelling, offers that are hard to ignore, and fast execution.",
        solution: [
            { title: "Audience Research & Market Targeting", copy: "Before launching any campaigns, we took time to understand Vantage Markets' target audience across key markets. We analysed trader behaviour, audience interests, and demographics. We also analysed their competitors and market opportunities to identify the segments most likely to engage with the brand and convert into active clients." },
            { title: "Multi-Channel Paid Advertising Campaigns", copy: "We developed and managed paid advertising campaigns across multiple channels, including Google, Meta, TikTok, LinkedIn, and other relevant platforms. This allowed us to reach potential traders at different stages of their decision-making journey while maximizing visibility across key touchpoints." },
            { title: "Programmatic Advertising", copy: "To expand reach and improve targeting, we leveraged programmatic advertising to place Vantage Markets in front of highly relevant audiences across premium websites and digital platforms. This helped increase brand awareness while supporting lead generation efforts." },
            { title: "Creative & Messaging Development", copy: "Our team created campaign creatives and marketing messages designed to capture attention and communicate Vantage Markets' value proposition clearly. Every creative asset was developed with the target audience in mind, ensuring relevance and stronger engagement." },
            { title: "Landing Page Optimization", copy: "We reviewed and provided recommendations to improve landing page performance, helping communicate better, reduce low quality leads, and give our audience better UI interaction." },
            { title: "Campaign Monitoring & Performance Optimization", copy: "We continuously monitored performance, tracked key metrics, and made data-driven adjustments, improving campaign efficiency, reducing wasted spend, and maximizing overall results." },
            { title: "Reporting, Insights & Strategic Collaboration", copy: "We worked closely with the Vantage Markets team throughout the campaign, providing regular performance reports and actionable insights, identifying new opportunities and refining our approach over time." }
        ],
        results: [
            { value: "65%+", label: "Increase in qualified leads" },
            { value: "20,000+", label: "Leads generated within 6 months" },
            { value: "3.8x", label: "Return on ad spend" },
            { value: "32%", label: "Lower cost per lead" },
            { value: "47%+", label: "Increase in audience engagement" },
            { value: "Multi-market", label: "Increased reach across key African markets" }
        ],
        resultsFootnote: "Beyond immediate campaign performance, we helped build a scalable marketing framework that provided valuable insights into audience behaviour and campaign performance for future growth initiatives.",
        ctaHeading: "Ready to Generate Better Leads?",
        ctaBody: "Whether you are a forex broker, fintech company or asset manager, Adxfusion helps brands attract the right audience, generate quality leads, and grow faster through performance-driven marketing.",
        ctaButton: "Let's talk about your growth goals"
    },
    {
        slug: "scope-markets-360-digital",
        client: "Scope Markets",
        service: "360 Digital Marketing",
        image: "https://static.prod-images.emergentagent.com/jobs/53238dfc-9902-4045-ab2f-6fcec5697290/images/db6f112ec4c0103c39f5f2290b9b90e3826f5dd9e8d9f6ab51a02642cff72f61.png",
        about: "Scope Markets is a global brokerage firm offering traders access to the financial markets, including forex, commodities, indices, and multi-asset instruments. The company is focused on providing a reliable trading environment, advanced trading technology, and strong customer support across multiple regions.",
        briefLabel: "The Challenge",
        brief: "Scope Markets wanted to strengthen its overall digital presence and improve how it connected with traders across key markets. The brand was already active online, but there was a need for a more structured and consistent marketing approach that could improve visibility, engagement, and lead quality across different channels. Scope Markets needed a digital marketing partner that could handle strategy, content, advertising, and brand communication.",
        solution: [
            { title: "Digital Strategy & Market Research", copy: "We started by understanding Scope Markets' target audience, the industry, and market opportunities. This helped us identify the most effective channels, messaging, and content angles needed to connect with potential clients." },
            { title: "Social Media Management & Brand Communication", copy: "We managed and optimized Scope Markets' social media presence to create a more consistent and professional brand image. Our team developed engaging content, managed posting schedules, and improved audience interaction across platforms." },
            { title: "Advertising Campaigns", copy: "To expand reach and attract qualified prospects, we launched targeted advertising campaigns across Google, Meta, LinkedIn, and other relevant platforms, designed to increase awareness and visibility, drive engagement, and lead generation." },
            { title: "Content Marketing & Creative Development", copy: "We designed content strategies and campaign creatives that spoke directly to the target audience, communicating Scope Markets' value clearly while encouraging stronger audience engagement." },
            { title: "Website Optimization", copy: "We reviewed Scope Markets' website and provided recommendations to improve website performance through SEO and SEM activities, aiming to improve conversions from marketing traffic." },
            { title: "Campaign Optimization & Reporting", copy: "We monitored campaign performance, analyzed audience behaviour, and optimized campaigns based on data, providing regular reports and insights to help Scope Markets make more informed marketing decisions." }
        ],
        results: [
            { value: "58%+", label: "Increase in qualified leads" },
            { value: "13,000+", label: "Leads generated within 6 months" },
            { value: "42%+", label: "Growth in social media engagement" },
            { value: "35%", label: "Lower cost per acquisition" },
            { value: "Multi-market", label: "Expanded brand reach across key African markets" },
            { value: "Consistent", label: "Stronger online brand presence" }
        ],
        resultsFootnote: "Beyond the numbers, the campaigns helped Scope Markets gain deeper insights into audience behaviour and build a more scalable digital marketing structure for long-term growth.",
        ctaHeading: "The only problem you have right now is not talking to us.",
        ctaBody: "Talk to us, let's help you solve it.",
        ctaButton: "Talk to us"
    },
    {
        slug: "multibank-search-engine-marketing",
        client: "MultiBank Group",
        service: "Search Engine Marketing",
        image: "https://static.prod-images.emergentagent.com/jobs/53238dfc-9902-4045-ab2f-6fcec5697290/images/c39835a31f4fd728c26555b38447392892f1d6b26e57044f0b13e047f37de3b7.png",
        about: "MultiBank Group is one of the world's leading financial derivatives providers, offering traders access to forex, commodities, indices, shares, and other financial instruments.",
        briefLabel: "The Challenge",
        brief: "MultiBank Group had good visibility but struggled with lead generation and conversion. To solve this challenge, they wanted to generate more leads and clients through SEO and SEM to increase their online visibility and trust levels amongst their target audience.",
        solution: [
            { title: "SEO Audit & Competitor Research", copy: "We reviewed MultiBank's website to identify areas for improvement and understand what was limiting search performance. We also analyzed competing brokers to see how they ranked on Google and identify opportunities MultiBank could take advantage of." },
            { title: "Keyword Research", copy: "We identified the search terms traders were using when looking for brokers, trading platforms, account types, and other trading-related services, helping us focus on the right keywords for traffic, engagement, and conversions." },
            { title: "Website SEO Improvements", copy: "We optimized important pages across the website by improving page titles, descriptions, content structure, internal links, and other areas that help improve Google rankings." },
            { title: "Content Recommendations", copy: "We provided recommendations for new blog content as well as improvements to existing pages to help MultiBank rank higher on search engines, aiming to answer common trader questions while bringing more organic traffic to the website." },
            { title: "Google Ads Campaign Management", copy: "We created and managed Google Ads campaigns using deeply researched keywords, consumer insights, and market insights, targeting people actively searching for the company's services, focused on generating quality leads and maximizing ad budget performance." },
            { title: "Landing Page Improvements", copy: "We reviewed key landing pages and provided recommendations to improve messaging, user experience, and increase conversions." },
            { title: "Monitoring & Reporting", copy: "Throughout the campaign, we tracked rankings, website traffic, lead generation, and advertising performance, sharing regular reports and using the data to make ongoing improvements." }
        ],
        results: [
            { value: "72%+", label: "Increase in organic website traffic" },
            { value: "24,000+", label: "Visitors" },
            { value: "4.1x", label: "Return on Google Ads spend" },
            { value: "38%", label: "Lower cost per acquisition" },
            { value: "55%+", label: "Increase in first-page Google rankings" },
            { value: "Higher", label: "Visibility across key African markets" }
        ],
        resultsFootnote: "Beyond the numbers, the project gave MultiBank a clearer understanding of how potential clients search online and what drives stronger marketing performance.",
        ctaHeading: "Ready to Get Found by the Right Audience?",
        ctaBody: "Whether you are a forex broker, fintech company, asset manager, or trading platform, ADXFUSION helps brands increase visibility, attract quality leads, and grow through SEO and paid advertising.",
        ctaButton: "Let's talk about your growth goals"
    },
    {
        slug: "oneroyal-seo-content-marketing",
        client: "OneRoyal",
        service: "SEO Content Marketing",
        image: "https://static.prod-images.emergentagent.com/jobs/53238dfc-9902-4045-ab2f-6fcec5697290/images/148a63fdc8b99149b84b0a424e86becd110e252612e834e2e9a907e9522a44f2.png",
        about: "OneRoyal is a global brokerage firm with over 20 years of experience in the financial markets. The company provides traders with access to forex, commodities, indices, shares, and other financial instruments.",
        briefLabel: "The Challenge",
        brief: "OneRoyal had a growing library of educational content, market analysis, company announcements, and trading resources. However, there was an opportunity to get more value from this content by improving its visibility on Google and attracting more traders through organic search. They wanted us to optimize their content bank with content that traders were actively searching for, improve search rankings, increase website traffic, and position OneRoyal as a trusted source of market information and trading education.",
        solutionLabel: "What We Did",
        solution: [
            { title: "Content Audit & Research", copy: "We reviewed OneRoyal's existing content to understand what was performing well and where there were opportunities for improvement, and identified content gaps that could bring additional traffic to the website." },
            { title: "Keyword Research", copy: "We identified keywords related to forex trading, gold trading, risk management, market analysis, trading psychology, and more." },
            { title: "SEO Content Strategy", copy: "We developed a content plan designed to support different stages of the trader journey, including educational articles, market updates, trading guides, company news, and evergreen content that could continue attracting traffic over time." },
            { title: "Content Creation & Optimization", copy: "We created and optimized articles to make them more useful, easier to read, and easier to find on Google, improving headlines, page structure, keyword placement, internal links, backlinking, and overall content quality." },
            { title: "Internal Linking", copy: "We implemented a strategic internal linking structure, content clusters across the website, to link related articles, educational resources, market analysis, and trading guides to one another, strengthening page authority and topic relevance." },
            { title: "Performance Monitoring & Reporting", copy: "We continuously monitored content performance, keyword rankings, organic traffic, and user engagement to understand how audiences were interacting with the content, using this to guide ongoing optimization." }
        ],
        results: [
            { value: "35%+", label: "Increase in organic website traffic" },
            { value: "120+", label: "SEO content assets published & optimized" },
            { value: "38%+", label: "Increase in first-page SERP rankings" },
            { value: "52%", label: "Increase in dwell time" },
            { value: "35,000+", label: "Organic visits generated within 12 months" }
        ],
        resultsFootnote: "",
        ctaHeading: "Ready to Turn Content Into Growth?",
        ctaBody: "Whether you are a forex broker, fintech company, asset manager, or trading platform, ADXFUSION helps brands create content that ranks, attracts the right audience, and supports business growth.",
        ctaButton: "Book a consultation"
    }
];

export const STATS = [
    { value: "$60M+", label: "Media budget managed (combined)" },
    { value: "39", label: "Markets activated (combined)" },
    { value: "21 yrs", label: "Combined financial services experience" },
    { value: "188+", label: "Campaigns launched (combined)" }
];

export const VALUES = [
    {
        slug: "specialists",
        kicker: "Principle 01",
        title: "Specialists, not generalists.",
        copy: "We work with financial and trading brands, nothing else. Everyone on the team has worked inside the industry, not next to it."
    },
    {
        slug: "performance",
        kicker: "Principle 02",
        title: "Performance is the brand.",
        copy: "In financial markets, taste and numbers are the same conversation. We build identities that scale on paid as hard as they look on billboards."
    },
    {
        slug: "compliance",
        kicker: "Principle 03",
        title: "Compliance-fluent by default.",
        copy: "From the FSCA in South Africa to the CMA in Kenya to SEC Nigeria, we know what you can say, where, and how to say it so it still converts."
    },
    {
        slug: "longterm",
        kicker: "Principle 04",
        title: "Long-term over loud.",
        copy: "Most of our partnerships are measured in years, not campaigns. We optimise for LTV, not lift charts."
    }
];
